import { Validation } from './rules/validation.interface';

export class TextareaModel {

  isAuth: boolean;
  isMidleWidth: boolean;
  placeholder: string;
  validators: Validation[] = new Array<Validation>();
  readOnly: boolean;
  isUpperCase: boolean;

  // tslint:disable-next-line:max-line-length
  constructor(_isAuth?: boolean, _isMidleWidth?: boolean, _placeholder?: string, _validators?: Validation[]) {
    this.isAuth = _isAuth;
    this.isMidleWidth = _isMidleWidth;
    this.placeholder = _placeholder;
    this.validators = _validators;
  }

  setReadOnly() {
    this.readOnly = true;
  }

  disableReadOnly() {
    this.readOnly = false;
  }

  setUpperCase() {
    this.isUpperCase = true;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/textarea/textarea.model.ts